import React, { useContext } from 'react'
import { LeadOrder, updateLeadOrderStatusPayload } from '../../../models/axiosModel';
import { Divider, Grid, Typography } from '@mui/material';
import popupStyles from "../../../assets/styles/componentStyles/globalPopupStyles.module.scss"
import GlobalButton from '../../../components/utility/globalButton/button';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import agent from '../../../services/api';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface UpdateLeadStatusPopupProps {
    selectedLead: LeadOrder,
    onCloseOfUpdateStatusPopup: () => void,
    getLeadOrderApiCallAfterUpdate: () => void,
}

const UpdateLeadStatusPopup: React.FC<UpdateLeadStatusPopupProps> = (props) => {
    
    const { selectedLead, onCloseOfUpdateStatusPopup, getLeadOrderApiCallAfterUpdate } = props;
    
    const {  setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const onClickOfSaveBtn = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const payload: updateLeadOrderStatusPayload = {
            sales_lead_meta_id: selectedLead?.sales_lead_meta_id ?? '',
            sales_lead_status_name: 'Purchase',
            ecom_order_amount: selectedLead?.ecom_order_amount ?? 0,
            ecom_order_currency: selectedLead?.ecom_order_currency ?? ''
        }
        const res = await agent.updateLeadOrderStatus.put(payload);
        if(!(res?.status)){
            handleError(res);
        } else {
            showSuccess('Lead Status Updated Successfully')
            getLeadOrderApiCallAfterUpdate();
            onCloseOfUpdateStatusPopup();
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    return (
        <>
            <Grid xs={12}>
                <Grid container direction={"column"} justifyContent={"center"}>
                    <Grid item textAlign={"center"}>
                        <Typography className={popupStyles.popupTitleTypography}>
                            {`Update Lead Status for ${selectedLead?.sales_lead_name}`}
                        </Typography>
                    </Grid>

                    <Divider className={popupStyles.popupTitleDivider} />

                    <Grid item xs={12} className={popupStyles.popupBodyGridContainer}>
                        <Typography className={popupStyles.popupFieldTypography}>
                            Are you sure you want to update the Lead status to "Purchase"?
                        </Typography>
                    </Grid>

                    <Grid item>
                        <Grid container justifyContent={"center"} alignItems={"center"} gap={"12px"} sx={{ padding: "20px 0" }}>
                            <Grid item>
                                <GlobalButton
                                    buttonText="Cancel"
                                    sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                    className='borderedButtonStyle'
                                    onClick={() => onCloseOfUpdateStatusPopup()}
                                />
                            </Grid>
                            <Grid item>
                                <GlobalButton
                                    buttonText="Update"
                                    sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                    className='primaryButtonStyle'
                                    onClick={() => onClickOfSaveBtn()}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>  
        </>
    )
}

export default UpdateLeadStatusPopup
